import { FC } from "react";
import { PartnersManagement } from "@/components/admin/partners/PartnersManagement";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { Helmet } from "react-helmet";
import { Users } from 'lucide-react';

const PartnersPage: FC = () => {
  return (
    <>
      
      <AdminLayout>
        <div className="container mx-auto px-4 py-4 md:py-8 max-w-7xl">
          <div className="flex items-center mb-8">
            <div className="flex items-center gap-3">
              <Users className="w-8 h-8 text-primary" />
              <h1 className="text-3xl font-bold text-gray-900">Administración de Socios</h1>
            </div>
          </div>
          <PartnersManagement />
        </div>
      </AdminLayout>
    </>
  );
};

export default PartnersPage;
